import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, ArrowRight, Tag, ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageHero } from './PageHero';
interface NewsItem {
  id: number;
  title: string;
  excerpt: string;
  date: string;
  category: string;
  image: string;
  featured?: boolean;
}
const categories = ['Всі', 'Змагання', 'Федерація', 'Скелелазіння', 'Альпінізм', 'Міжнародні'];
export const newsData: NewsItem[] = [{
  id: 1,
  title: 'Чемпіонат України зі скелелазіння 2025: результати та підсумки',
  excerpt: 'У Києві завершився Чемпіонат України зі скелелазіння у дисциплінах боулдеринг та трудність. Понад 120 спортсменів з 18 регіонів взяли участь у змаганнях.',
  date: '18 лютого 2026',
  category: 'Змагання',
  image: 'https://images.unsplash.com/photo-1522163182402-834f871fd851?w=800&q=80',
  featured: true
}, {
  id: 2,
  title: 'Збірна України на Чемпіонаті Європи з льодолазіння',
  excerpt: 'Українські спортсмени вибороли дві бронзові медалі на Чемпіонаті Європи з льодолазіння в Австрії.',
  date: '12 лютого 2026',
  category: 'Міжнародні',
  image: 'https://images.unsplash.com/photo-1533692328991-08159ff19fca?w=800&q=80'
}, {
  id: 3,
  title: 'Затверджено календар змагань на 2026 рік',
  excerpt: 'Виконком ФАіСУ затвердив офіційний календар змагань на 2026 рік, що включає понад 40 заходів по всій Україні.',
  date: '5 лютого 2026',
  category: 'Федерація',
  image: 'https://images.unsplash.com/photo-1454496522488-7a8e488e8606?w=800&q=80'
}, {
  id: 4,
  title: 'Відкрито реєстрацію на Кубок України з боулдерингу',
  excerpt: 'Стартувала онлайн-реєстрація на перший етап Кубка України з боулдерингу, який відбудеться у Львові.',
  date: '1 лютого 2026',
  category: 'Змагання',
  image: 'https://images.unsplash.com/photo-1564769662533-4f00a87b4056?w=800&q=80'
}, {
  id: 5,
  title: 'Школа інструкторів з альпінізму: набір учасників',
  excerpt: 'ФАіСУ оголошує набір на щорічну школу інструкторів з альпінізму. Навчання розпочнеться у квітні.',
  date: '28 січня 2026',
  category: 'Альпінізм',
  image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&q=80'
}, {
  id: 6,
  title: 'Нові правила присвоєння спортивних розрядів',
  excerpt: 'Внесено зміни до порядку присвоєння спортивних розрядів та звань з альпінізму та скелелазіння.',
  date: '20 січня 2026',
  category: 'Федерація',
  image: 'https://images.unsplash.com/photo-1505567745926-ba89000d255a?w=800&q=80'
}, {
  id: 7,
  title: 'Етап Кубка світу зі скелелазіння: Україна у фіналі',
  excerpt: 'Двоє українських скелелазів вийшли до фіналу етапу Кубка світу зі швидкості в Сеулі.',
  date: '15 січня 2026',
  category: 'Скелелазіння',
  image: 'https://images.unsplash.com/photo-1601226036825-423531557022?w=800&q=80'
}, {
  id: 8,
  title: 'Підсумки зимового сезону альпінізму 2025/2026',
  excerpt: 'Огляд основних досягнень українських альпіністів протягом зимового сезону: сходження, експедиції та нові маршрути.',
  date: '10 січня 2026',
  category: 'Альпінізм',
  image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=800&q=80'
}, {
  id: 9,
  title: 'Семінар з безпеки в горах: онлайн-формат',
  excerpt: 'ФАіСУ проводить серію онлайн-семінарів з безпеки в горах для початківців та досвідчених альпіністів.',
  date: '5 січня 2026',
  category: 'Федерація',
  image: 'https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=800&q=80'
}, {
  id: 10,
  title: 'Юнацький чемпіонат України зі скелелазіння',
  excerpt: 'У Дніпрі відбувся юнацький чемпіонат зі скелелазіння. Молоді спортсмени продемонстрували високий рівень підготовки.',
  date: '28 грудня 2025',
  category: 'Змагання',
  image: 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&q=80'
}, {
  id: 11,
  title: 'Партнерство з UIAA: нові можливості для українських спортсменів',
  excerpt: 'Підписано оновлену угоду про співпрацю з Міжнародним союзом альпіністських асоціацій.',
  date: '20 грудня 2025',
  category: 'Міжнародні',
  image: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?w=800&q=80'
}, {
  id: 12,
  title: 'Відкриття нового скеледрому у Харкові',
  excerpt: 'У Харкові відкрито сучасний скеледром міжнародного рівня, який відповідає стандартам IFSC.',
  date: '15 грудня 2025',
  category: 'Скелелазіння',
  image: 'https://images.unsplash.com/photo-1606859309981-748e0b0a5046?w=800&q=80'
}, {
  id: 13,
  title: 'Експедиція на Хан-Тенгрі: звіт команди',
  excerpt: 'Українська команда успішно завершила сходження на Хан-Тенгрі (7010 м) по новому маршруту.',
  date: '10 грудня 2025',
  category: 'Альпінізм',
  image: 'https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?w=800&q=80'
}, {
  id: 14,
  title: 'Зміни до статуту ФАіСУ: результати конференції',
  excerpt: 'На щорічній конференції федерації було затверджено зміни до статуту та обрано нових членів виконкому.',
  date: '5 грудня 2025',
  category: 'Федерація',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80'
}, {
  id: 15,
  title: 'Кубок України зі швидкості: нові рекорди',
  excerpt: 'На етапі Кубка України зі швидкості встановлено два нових національних рекорди серед чоловіків та жінок.',
  date: '28 листопада 2025',
  category: 'Змагання',
  image: 'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=800&q=80'
}, {
  id: 16,
  title: 'Міжнародні змагання з льодолазіння в Україні',
  excerpt: 'Вперше Україна прийме етап міжнародних змагань з льодолазіння. Захід відбудеться в Карпатах.',
  date: '20 листопада 2025',
  category: 'Міжнародні',
  image: 'https://images.unsplash.com/photo-1491002052546-bf38f186af56?w=800&q=80'
}, {
  id: 17,
  title: 'Програма розвитку дитячого скелелазіння',
  excerpt: 'ФАіСУ запускає національну програму розвитку дитячого скелелазіння у 15 містах України.',
  date: '15 листопада 2025',
  category: 'Федерація',
  image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&q=80'
}, {
  id: 18,
  title: 'Осінній чемпіонат з боулдерингу: підсумки',
  excerpt: 'Завершився осінній чемпіонат з боулдерингу. Визначено переможців у всіх вікових категоріях.',
  date: '10 листопада 2025',
  category: 'Скелелазіння',
  image: 'https://images.unsplash.com/photo-1578886524768-5fe4ca843f50?w=800&q=80'
}];
const ITEMS_PER_PAGE = 6;
interface NewsProps {
  preview?: boolean;
}
export function News({
  preview = false
}: NewsProps) {
  const [activeCategory, setActiveCategory] = useState('Всі');
  const [currentPage, setCurrentPage] = useState(1);
  const filteredNews = activeCategory === 'Всі' ? newsData : newsData.filter(item => item.category === activeCategory);
  const totalPages = Math.ceil(filteredNews.length / ITEMS_PER_PAGE);
  // Reset page when category changes
  useEffect(() => {
    setCurrentPage(1);
  }, [activeCategory]);
  // Preview mode: featured + 2 side cards (homepage)
  if (preview) {
    const featured = filteredNews.find(item => item.featured) || filteredNews[0];
    const previewRegular = filteredNews.filter(item => item.id !== featured?.id).slice(0, 2);
    return <section id="news" className="py-20 bg-white border-b border-gray-100" data-id="element-308">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-309">
          <div className="text-center mb-10" data-id="element-310">
            <span className="text-primary/50 font-semibold tracking-wider uppercase text-xs" data-id="element-311">
              Останні оновлення
            </span>
            <h2 className="mt-2 text-3xl font-heading font-bold text-primary" data-id="element-312">
              Новини
            </h2>
            <p className="mt-4 text-base text-gray-600 max-w-2xl mx-auto" data-id="element-313">
              Актуальна інформація про діяльність федерації, змагання та події у
              світі альпінізму і скелелазіння.
            </p>
          </div>

          {featured && <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-314">
              <Link to={`/news/${featured.id}`} className="block lg:row-span-2 bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden group cursor-pointer" data-id="element-315">
                <div className="relative h-64 lg:h-full min-h-[280px] overflow-hidden" data-id="element-316">
                  <img src={featured.image} alt={featured.title} className="w-full h-full object-cover" data-id="element-317" />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent" data-id="element-318" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8" data-id="element-319">
                    <div className="flex items-center gap-3 mb-3" data-id="element-320">
                      <span className="px-2.5 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-semibold rounded" data-id="element-321">
                        {featured.category}
                      </span>
                      <span className="flex items-center text-white/70 text-xs" data-id="element-322">
                        <Calendar className="h-3 w-3 mr-1.5" data-id="element-323" />
                        {featured.date}
                      </span>
                    </div>
                    <h3 className="text-xl lg:text-2xl font-heading font-bold text-white mb-2 leading-snug" data-id="element-324">
                      {featured.title}
                    </h3>
                    <p className="text-white/80 text-sm leading-relaxed hidden sm:block" data-id="element-325">
                      {featured.excerpt}
                    </p>
                  </div>
                </div>
              </Link>
              {previewRegular.map(item => <Link key={item.id} to={`/news/${item.id}`} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden flex flex-col sm:flex-row cursor-pointer group" data-id="element-326">
                  <div className="sm:w-48 h-40 sm:h-auto flex-shrink-0 overflow-hidden" data-id="element-327">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-328" />
                  </div>
                  <div className="p-5 flex flex-col justify-center" data-id="element-329">
                    <div className="flex items-center gap-3 mb-2" data-id="element-330">
                      <span className="flex items-center text-xs font-semibold text-primary/70" data-id="element-331">
                        <Tag className="h-3 w-3 mr-1" data-id="element-332" />
                        {item.category}
                      </span>
                      <span className="text-gray-400 text-xs" data-id="element-333">{item.date}</span>
                    </div>
                    <h4 className="text-base font-bold text-primary mb-1.5 leading-snug group-hover:text-primary-light transition-colors" data-id="element-334">
                      {item.title}
                    </h4>
                    <p className="text-gray-500 text-sm leading-relaxed line-clamp-2 hidden sm:block" data-id="element-335">
                      {item.excerpt}
                    </p>
                  </div>
                </Link>)}
            </div>}

          <div className="text-center mt-12" data-id="element-336">
            <Link to="/news" className="inline-flex items-center px-6 py-2.5 border border-gray-300 text-primary rounded-md font-semibold text-sm hover:bg-gray-50 transition-colors" data-id="element-337">
              Всі новини
              <ArrowRight className="ml-2 h-4 w-4" data-id="element-338" />
            </Link>
          </div>
        </div>
      </section>;
  }
  // Full news page with 6-per-page grid + pagination
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedNews = filteredNews.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <section id="news" data-id="element-339">
      <PageHero label="Архів новин" title="Новини" subtitle="Актуальна інформація про діяльність федерації, змагання та події у світі альпінізму і скелелазіння." data-id="element-340" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-341">
        {/* Category Tabs */}
        <div className="flex justify-center mb-12" data-id="element-342">
          <div className="flex flex-wrap justify-center gap-2" data-id="element-343">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${activeCategory === category ? 'bg-primary text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-344">
                {category}
              </button>)}
          </div>
        </div>

        {/* Results count */}
        <div className="mb-6 text-sm text-gray-500" data-id="element-345">
          {filteredNews.length}{' '}
          {filteredNews.length === 1 ? 'новина' : filteredNews.length < 5 ? 'новини' : 'новин'}
          {activeCategory !== 'Всі' && <span data-id="element-346"> у категорії «{activeCategory}»</span>}
        </div>

        {/* News Grid — 6 per page */}
        <AnimatePresence mode="wait" data-id="element-347">
          <motion.div key={`${activeCategory}-${currentPage}`} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.3
        }} data-id="element-348">
            {paginatedNews.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-349">
                {paginatedNews.map((item, index) => <motion.div key={item.id} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.06,
              duration: 0.4
            }} data-id="element-350">
                    <Link to={`/news/${item.id}`} className="block h-full bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden cursor-pointer group" data-id="element-351">
                      <div className="h-48 overflow-hidden" data-id="element-352">
                        <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-353" />
                      </div>
                      <div className="p-5" data-id="element-354">
                        <div className="flex items-center gap-3 mb-2" data-id="element-355">
                          <span className="flex items-center text-xs font-semibold text-primary/70" data-id="element-356">
                            <Tag className="h-3 w-3 mr-1" data-id="element-357" />
                            {item.category}
                          </span>
                          <span className="text-gray-400 text-xs" data-id="element-358">
                            {item.date}
                          </span>
                        </div>
                        <h4 className="text-base font-bold text-primary mb-1.5 leading-snug group-hover:text-primary-light transition-colors" data-id="element-359">
                          {item.title}
                        </h4>
                        <p className="text-gray-500 text-sm leading-relaxed line-clamp-2" data-id="element-360">
                          {item.excerpt}
                        </p>
                      </div>
                    </Link>
                  </motion.div>)}
              </div> : <div className="text-center py-16 text-gray-400" data-id="element-361">
                <p className="text-lg font-medium" data-id="element-362">
                  Новин у цій категорії поки немає
                </p>
              </div>}
          </motion.div>
        </AnimatePresence>

        {/* Pagination */}
        {totalPages > 1 && <nav className="flex items-center justify-center gap-1 mt-12" aria-label="Пагінація" data-id="element-363">
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="p-2 rounded-md text-gray-500 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors" aria-label="Попередня сторінка" data-id="element-364">
              <ChevronLeft className="h-5 w-5" data-id="element-365" />
            </button>

            {Array.from({
          length: totalPages
        }, (_, i) => i + 1).map(page => <button key={page} onClick={() => handlePageChange(page)} className={`w-10 h-10 rounded-md text-sm font-semibold transition-colors ${currentPage === page ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-100'}`} aria-label={`Сторінка ${page}`} aria-current={currentPage === page ? 'page' : undefined} data-id="element-366">
                {page}
              </button>)}

            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-2 rounded-md text-gray-500 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors" aria-label="Наступна сторінка" data-id="element-367">
              <ChevronRight className="h-5 w-5" data-id="element-368" />
            </button>
          </nav>}
      </div>
    </section>;
}